import { ArrowLeft, BookOpen } from "lucide-react";

import { LinkButton } from "./ui";

export function NotFoundPage() {
  return (
    <main className="relative min-h-screen overflow-hidden pt-16">
      <div className="download-bg absolute inset-0 z-0 bg-bg">
        <div className="absolute inset-0 bg-gt-grid opacity-35" />
        <div className="absolute inset-0 bg-bg/34" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-gradient-to-b from-transparent to-bg" />
      </div>

      <section className="relative z-10 mx-auto flex min-h-[calc(100vh-4rem)] max-w-7xl items-center px-6 py-24">
        <div className="relative w-full overflow-hidden rounded-xl border border-border bg-surface p-8 shadow-2xl shadow-black/25 md:p-12">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-8 top-1/2 -translate-y-1/2 font-display text-[12rem] font-bold leading-none text-transparent opacity-25 [-webkit-text-stroke:1px_var(--primary)] md:text-[20rem]"
          >
            404
          </div>

          <div className="relative z-10 max-w-2xl">
            <div className="mb-6 flex items-center gap-3">
              <div className="h-px w-10 bg-primary" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary">Route Not Found</span>
            </div>
            <h1 className="mb-6 font-display text-6xl font-bold uppercase leading-[0.9] text-text md:text-8xl">
              You&apos;re off
              <br />
              the racing line.
            </h1>
            <p className="mb-8 max-w-xl text-lg leading-relaxed text-muted">
              The page you requested is not available. Head back to iBox or jump into the docs to find the right line.
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <LinkButton href="/" size="lg">
                <ArrowLeft size={16} /> Back Home
              </LinkButton>
              <LinkButton href="/docs/" variant="ghost" size="lg">
                <BookOpen size={14} /> View Docs
              </LinkButton>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
